import {required, minLength, maxLength, email, sameAs, helpers, requiredIf} from 'vuelidate/lib/validators';

const touchMap = new WeakMap();
const alpha = helpers.regex('alpha', /^[а-яА-Я \-\.]*$/);
const date = helpers.regex('alpha', /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/);

let requiredRule = {
    required
};

let nameRule = {
    required,
    minLength: minLength(4),
    maxLength: maxLength(50)
};

let phoneRule = {
    required,
    maxLength: maxLength(16),
    minLength: minLength(10)
};


let passwordRule = {
    required,
    minLength: minLength(8),
};


let passwordRepeatRule = {
    required,
    minLength: minLength(8),
    sameAs: sameAs('password')
};

let emailRule = {
    email
};
let emailReqRule = {
    required,
    email
};
let checkbox = {
    required,
    sameAs: sameAs(() => true)
};

let onlyLetterRule = {
    alpha
};

let deliveryAddressRule = {
    required: requiredIf(function () {
        let valid = false;
        if(this.order.delivery_type.indexOf( 60129542270) != -1) valid = true;
        return valid
    })
};

let pickUpAddressRule = {
    required: requiredIf(function () {
        let valid = false;
        if(this.order.delivery_type.indexOf(60129542271) != -1 && !this.order.state.pick_up_as_delivery) valid = true;
        return valid
    })
};

let reqEmailIfPerson = {
    email,
    required: requiredIf(function () {
        let valid = false;
        if(this.postData.type === 'Физическое лицо') valid = true;
        return valid
    })
};

let reqIfPerson = {
    required: requiredIf(function () {
        let valid = false;
        if(this.postData.type === 'Физическое лицо') valid = true;
        return valid
    })
};

let reqDateIfPerson = {
    minLength: minLength(10),
    maxLength: maxLength(10),
    date,
    required: requiredIf(function () {
        let valid = false;
        if(this.postData.type === 'Физическое лицо') valid = true;
        return valid
    })
};

let reqIfOrganization = {
    required: requiredIf(function () {
        let valid = false;
        if(this.postData.type === 'Юридическое лицо') valid = true;
        return valid
    })
};

let reqDateIfOrganization = {
    minLength: minLength(10),
    maxLength: maxLength(10),
    date,
    required: requiredIf(function () {
        let valid = false;
        if(this.postData.type === 'Юридическое лицо') valid = true;
        return valid
    })
};

let delivery_distance = {
    required: requiredIf(function () {
        let valid = false;
        if(this.order.postData.delivery_outside == 2) valid = true;
        else valid = false;
        return valid
    })
};

let pick_up_distance = {
    required: requiredIf(function () {
        let valid = false;
        if(this.order.postData.pick_up_outside == 2 && this.order.delivery_type.indexOf(60129542271) != -1 && !this.order.state.pick_up_as_delivery) valid = true;
        else valid = false;
        return valid
    })
};

export {
    requiredRule,
    nameRule,
    checkbox,
    passwordRule,
    passwordRepeatRule,
    onlyLetterRule,
    deliveryAddressRule,
    pickUpAddressRule,
    emailRule,
    emailReqRule,
    reqEmailIfPerson,
    reqIfPerson,
    reqDateIfPerson,
    reqIfOrganization,
    reqDateIfOrganization,
    phoneRule,
    delivery_distance,
    pick_up_distance
};
